export default "__VITE_ASSET__DFVdtg0t__"